// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qaMJGaFjwlPkXc {
  vertical-align: text-top;
}
.ynXsALMvTdWNSH {
  margin: var(--ds-space-100, 8px) var(--ds-space-0, 0);
}
.we0Z8HnUw3En3y {
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0);
}
.SUi38lmySugH4l {
  display: flex;
  justify-content: center;
  margin-top: var(--ds-space-100, 8px);
}
.SUi38lmySugH4l .LIQVglj_0ssHWx {
  margin-right: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
export var headerIcon = `qaMJGaFjwlPkXc`;
export var divider = `ynXsALMvTdWNSH`;
export var button = `we0Z8HnUw3En3y`;
export var feedbackButton = `SUi38lmySugH4l`;
export var feedbackIcon = `LIQVglj_0ssHWx`;
export default ___CSS_LOADER_EXPORT___;
